<template>
    <Panel class="flex flex-col w-full pb-2">
        <div class="divide-y-2 divide-zinc-900 flex flex-col w-full gap-4">
        <div
            class="flex items-center justify-between pb-4"
            v-for="player in players"
            :key="player.friend.id"
            data-testid="friend-item"
            :data-friend-name="player.friend.tag_name"
            @click="matchStatus(player) ? null : $emit('action', player.friend)"
        >
            <div class="flex items-center space-x-3" :class="{ 'w-full': !showButton, 'opacity-50': isLoading(player) }">
                <div class="relative">
                    <img v-avatar-fallback="player.friend.avatar" alt="" class="border-stroke-1 h-10 w-10 border" />
                </div>
                <div class="flex-1 ">
                    <div class="text-sm font-semibold text-white flex items-center gap-2">
                        <div v-if="isOnline(player)" class=" h-1.5 w-1.5 rounded-full bg-green-500"></div>
                        <span class="leading-3">
                            {{ player.friend.tag_name }}
                        </span>
                    </div>
                    <p class="text-titles text-sm">
                        {{ player.friend.name }}
                    </p>
                </div>
            </div>
            <span
                v-if="matchStatus(player)"
                class="bg-zinc-900 shrink-0 border border-zinc-700 px-3 py-1.5 text-xs font-bold uppercase"
                :class="matchStatus(player) === 'joined' ? 'text-green-500' : 'text-orange-500'"
            >
                {{ matchStatus(player) === 'joined' ? $t('player_selector.joined_badge') : $t('player_selector.invite_sent_badge') }}
            </span>
            <svg v-else viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-3 w-3">
                <path d="M7 -3.0598e-07L7 5L12 5L12 7L7 7L7 12L5 12L5 7L3.0598e-07 7L2.18557e-07 5L5 5L5 -2.18557e-07L7 -3.0598e-07Z" fill="#FF2C2C"/>
            </svg>
        </div>
        </div>
    </Panel>
</template>

<script>
import Panel from '@/components/layout/Panel.vue';
import { isOnline } from '@/utils/presence.js'


    export default {
        name: 'PlayersList',
        emit: ['action'],
        props: {
            players: {
                type: Array,
                required: true,
            },
            loadingPlayer: {
                type: Number,
                default: null,
            },
            /** Match profiles keyed by friend id, to show a Joined/Invite sent badge instead of the add action. */
            matchProfilesByFriendId: {
                type: Map,
                default: () => new Map(),
            },
        },
        components: {
            Panel,
        },
        methods: {
            isOnline(player) {
                return isOnline(player.friend?.last_seen_at);
            },
            isLoading(player) {
                return this.loadingPlayer == player.friend.id;
            },
            /** 'joined' | 'invited' | null - null means not yet added to this match. */
            matchStatus(player) {
                const profile = this.matchProfilesByFriendId.get(player.friend.id)
                if (!profile) {
                    return null
                }
                return profile.ready ? 'joined' : 'invited'
            },
        },
    }
</script>